var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class SupportedDevicesService {
    GetServiceName() {
        return SupportedDevicesService.ServiceName;
    }
    GetSupportedDevicesAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            //updates.tr7.pl/supportedDevices/pl-PL.json
            const url = `https://updates.tr7.pl/supportedDevices/pl-PL.json`;
            let res = yield fetch(url, { method: 'GET' });
            if (res.ok)
                return JSON.parse(yield res.text());
            else
                throw new Error("Failed to download supported devices list!");
        });
    }
}
SupportedDevicesService.ServiceName = "SupportedDevicesService";
//# sourceMappingURL=SupportedDevicesService.js.map